import type { NostrEvent } from '@nostrify/nostrify';
import { Card, CardContent, CardFooter } from '@/components/ui/card';
import { extractVideoUrl, extractVideoTitle, extractVideoThumbnail } from '@/hooks/useVideos';
import { useState } from 'react';
import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog';
import { VideoThumbnail } from '@/components/VideoThumbnail';

interface VideoCardProps {
  event: NostrEvent;
}

export function VideoCard({ event }: VideoCardProps) {
  const videoUrl = extractVideoUrl(event);
  const title = extractVideoTitle(event);
  const thumbnail = extractVideoThumbnail(event);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  if (!videoUrl) return null;

  return (
    <Card className="overflow-hidden hover:shadow-xl transition-all duration-300 group">
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogTrigger asChild>
          <CardContent className="p-0">
            <VideoThumbnail
              videoUrl={videoUrl}
              thumbnailUrl={thumbnail}
              title={title}
              onThumbnailClick={() => setIsOpen(true)}
            />
          </CardContent>
        </DialogTrigger>
        <DialogContent className="max-w-4xl p-0">
          <video
            src={videoUrl}
            controls
            autoPlay
            className="w-full h-auto"
            onPlay={() => setIsPlaying(true)}
          >
            Your browser does not support the video tag.
          </video>
        </DialogContent>
      </Dialog>
      {(title || event.content) && (
        <CardFooter className="flex-col items-start p-4">
          {title && <h3 className="font-semibold mb-1">{title}</h3>}
          {event.content && (
            <p className="text-sm text-muted-foreground line-clamp-2">
              {event.content}
            </p>
          )}
        </CardFooter>
      )}
    </Card>
  );
}
